import gql from 'graphql-tag'

export const GET_VEHICLE_DOCS = gql`
  query VehicleDocs($filter: GetVehicleDocInputType!) {
    vehicleDocs(filter: $filter) {
      isSuccessful
      message
      vehicleDocs {
        licensePlate
        vehicleId
        docType
        docNumber
        validUntil
        status
      }
    }
  }
`

export const UPDATE_VEHICLE_DOCS = gql`
  mutation UpdateVehicleDoc($input: CreateVehicleDocInput!) {
    updateVehicleDoc(input: $input) {
      isSuccessful
      message
      updateVehicleDoc {
        licensePlate
        vehicleId
        docType
        docNumber
        validUntil
        status
      }
    }
  }
`

export const IMPORT_VEHICLE_DOCS = gql`
  mutation ImportVehicleDoc($input: ImportVehicleDocInput!) {
    importVehicleDoc(input: $input) {
      isSuccessful
      message
      importVehicleDoc {
        errorFile
        totalData
        totalFailed
        totalSuccess
      }
    }
  }
`

export const DOWNLOAD_EXCEL_VEHICLEDOCS = gql`
  query DownloadvehicleDocs($filter: GetVehicleDocInputType!) {
    downloadvehicleDocs(filter: $filter) {
      isSuccessful
      message
      vehicleDocs {
        base64
      }
    }
  }
`

export const GET_VEHICLE_DOC_TYPES = gql`
  query VehicleDocType($filter: GetLookupWithFilterInput) {
    vehicleDocType(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleDocTypes {
        data {
          companyId
          srcTable
          srcColumn
          text
          hasRelation
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_EMAIL_NOTIFICATIONS = gql`
  query EmailNotifications($filter: GetEmailNotificationsInput!) {
    emailNotifications(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      emailNotifications {
        data {
          emailNotificationId
          companyId
          userId
          nameGroupEmail
          email
          createdOn
          repetition
          reminder
          type
          docTypes
          createdBy
          aggregate {
            whatsapp
            email
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_EMAIL_NOTIFICATION = gql`
  query EmailNotification($filter: GetEmailNotificationInput) {
    emailNotification(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      emailNotification {
        emailNotificationId
        companyId
        userId
        nameGroupEmail
        email
        createdOn
        repetition
        reminder
        type
      }
    }
  }
`

export const GET_LICENSE_REMINDER = gql`
  query EmailLicenseNotificationDetails($filter: GetEmailLicenseNotificationDetailsInput) {
    emailLicenseNotificationDetails(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      emailLicenseNotificationDetails {
        emailNotificationId
        docTypes
      }
    }
  }
`
export const CREATE_EMAIL_NOTIFICATION = gql`
  mutation CreateEmailNotification($input: CreateEmailNotificationInput!) {
    createEmailNotification(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      emailNotification {
        emailNotificationId
        companyId
        userId
        nameGroupEmail
        email
        createdOn
        repetition
        reminder
        type
      }
    }
  }
`

export const UPDATE_EMAIL_NOTIFICATION = gql`
  mutation UpdateEmailNotification($input: UpdateEmailNotificationInput!) {
    updateEmailNotification(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      emailNotification {
        emailNotificationId
        companyId
        userId
        nameGroupEmail
        email
        createdOn
        repetition
        reminder
        type
      }
    }
  }
`

export const UPDATE_EMAIL_LICENSE_REMINDER = gql`
  mutation UpdateEmailLicenseNotificationDetails(
    $input: UpdateEmailLicenseNotificationDetailsInput!
  ) {
    updateEmailLicenseNotificationDetails(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      emailLicenseNotificationDetails {
        count
      }
    }
  }
`

export const DELETE_EMAIL_NOTIFICATION = gql`
  mutation DeleteEmailNotifications($input: DeleteEmailNotificationInput!) {
    deleteEmailNotifications(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      emailNotification {
        countDeletedEmailNotifications
        countDeletedEmailNotificationDetails
        countDeletedEmailLicenseNotificationDetails
      }
    }
  }
`
